import { resolveMeterColor } from "@next-platform/client-common-core";
import type { MeterColorTheme, MeterDefinition } from "@next-platform/packages-ts-types";

import type { RenderTokenChip } from "@/components/Rulebook/tokenChipTint";

import { describeRulebookToken } from "./rulebookTokens";

type CreateRulebookTokenRendererParams = {
  meters: MeterDefinition[];
  values: Record<string, number>;
  names: { user: string; char: string };
  emptyNowLabel: string;
  theme: MeterColorTheme;
};

const createRulebookTokenRenderer =
  ({ meters, values, names, emptyNowLabel, theme }: CreateRulebookTokenRendererParams): RenderTokenChip =>
  (raw) => {
    const described = describeRulebookToken({ raw, meters, values, names });
    if (described.kind === "meter") {
      const shown = described.value === "" ? emptyNowLabel : described.value;
      const chipColor = resolveMeterColor({ color: described.color, theme });
      return { tone: "meter", label: described.label, value: shown, ...(chipColor ? { color: chipColor } : {}) };
    }
    return { tone: described.kind === "name" ? "name" : "unknown", label: described.label };
  };

export default createRulebookTokenRenderer;
